.not-found-box {
  background-position: center;
  background-size: cover;
  /* calc 100vh - footer height - header height */
  height: calc(100vh - 60px - 66px);
  background-image: url("../styles/assets/404@0.25x.png");
  color: var(--bs-rk-pink);
  overflow: auto;
  width: 100%;
}

.not-found-box-text {
  padding: 20px;
  background-color: rgba(var(--bs-rk-blue-rgb), 0.7);
}
.not-found-box-text:first-of-type {
  padding: 20px;
  max-width: 700px;
}

@media (min-width: 1024px) {
  .not-found-box-text {
    margin: 0 50px;
  }
}

@media (min-width: 1500px) {
  .not-found-box {
    background-image: url("../styles/assets/404@0.5x.png");
  }
}

@media (min-width: 2200px) {
  .not-found-box {
    background-image: url("../styles/assets/404@0.75x.png");
    padding: 0 4rem;
  }
}
